module.exports = "/images/icon-unlocked.svg?213d9a14a92404b649c2e1b674c1619f";